module.exports = __webpack_public_path__ + "img/btn-swiper-play-control-02.2296d26a.svg";